import { useStore } from '@tanstack/react-store';
import { useMemo, useEffect } from 'react';
import { store, actions, initPersistence } from '../store';
import { VideoItem } from '../types';

export const useCampaigns = () => {
  useEffect(() => {
    initPersistence();
  }, []);

  const campaigns = useStore(store, (state) => state.campaigns);
  const selectedCampaignId = useStore(store, (state) => state.selectedCampaignId);

  const activeCampaign = useMemo(
    () => campaigns.find((c) => c.id === selectedCampaignId) || campaigns[0],
    [campaigns, selectedCampaignId]
  );

  const videoItems = activeCampaign?.videos || [];

  return {
    campaigns,
    selectedCampaignId,
    activeCampaign,
    videoItems,

    createCampaign: actions.createCampaign,
    deleteCampaign: actions.deleteCampaign,
    updateCampaign: actions.updateCampaign,
    updateActiveCampaignVideos: (videos: VideoItem[]) => {
      actions.setVideosToCampaign(videos);
    },
    updateVideoStatus: (id: string, updates: Partial<VideoItem>) => {
      actions.updateVideoStatus(id, updates);
    },

    setSelectedCampaignId: actions.setSelectedCampaignId,

    setCampaigns: () => console.warn('setCampaigns is deprecated in favor of store actions')
  };
};
